import React from "react";
import { TableCell } from "@/components/ui/table";
import StatusBadge from "@/components/StatusBadge";
import { STICKY_CELL } from "@/components/review/SubmissionReviewCard";
import { shortNo } from "@/lib/caseNo";

export const SUBMISSION_COLUMNS = ["Case #", "Member", "Achievement", "Pts", "Description", "Status", "Actions"];

export function SubmissionCells({ s, children }) {
  return (
    <>
      <TableCell className="font-mono text-xs font-semibold">{shortNo(s.case_number)}</TableCell>
      <TableCell className={`whitespace-nowrap text-sm font-medium ${STICKY_CELL}`}>{s.team_member_name}</TableCell>
      <TableCell className="text-sm">{s.achievement_label_snapshot}</TableCell>
      <TableCell className="font-bold tabular-nums text-violet-600">{s.points_requested_snapshot}</TableCell>
      <TableCell className="max-w-xs text-sm text-slate-600">{s.event_description}</TableCell>
      <TableCell className="max-w-[12rem]">
        <StatusBadge status={s.status} />
        {s.status === "returned_for_correction" && s.returned_comment && <p className="mt-1 text-xs text-violet-700">{s.returned_comment}</p>}
      </TableCell>
      <TableCell>{children}</TableCell>
    </>
  );
}
